import styled from '@emotion/styled';
import { getColor } from '../../common/UICommon';

export const ThanksForSharingLoaderWrapper = styled.div`
  text-align: center;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ThanksForSharingLoaderTitle = styled.h2`
  font-family: Lora;
  font-size: 32px;
  line-height: 36px;
  font-weight: 500;
  color: ${getColor('GRAY_80')};
  margin-bottom: 16px;
`;

export const ThanksForSharingLoaderDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${getColor('GRAY_50')};
  margin-top: 16px;
`;
